// Mirror of backend/src/config/notificationPreferences.js.
// Keep the keys in sync with the backend catalog.
export const NOTIFICATION_PREFERENCES = [
  {
    key: 'timesheetReminders',
    label: 'Timesheet reminders',
    description:
      'Friendly, overdue, and final-notice reminders to submit a timesheet.',
  },
];
